module.exports = __webpack_public_path__ + "img/no-detail.21ed865a.png";